import LoginSignUp from "./components/LoginSignUp/LoginSignUp"

function App() {
  return (
    <div>
      <LoginSignUp />
    </div>
  )
}

export default App